export default "__VITE_ASSET__7c1e70e2__"